export default __webpack_public_path__ + "static/media/wallhanging.7ad2850a.jpg";